import React from 'react'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'

import { safeInitializeGtm } from '@modules/utils/gtm'
import { createSentryBaseOptions } from '@modules/utils/sentryFilters'

import { App } from './App'
import { env, gtmId, sentryDsn } from './config'

import '@modules/scss/global.css'

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: env,
    // 送信データの範囲（dataCollection）と送信前フィルタは 3 アプリで共通。個別に書くと
    // 書き忘れても型・lint・テストのどれも落ちないまま、そのアプリだけ SDK の既定
    // （v11 は IP アドレス・Cookie・本文を収集する側）に戻るため、必ずここから展開する
    ...createSentryBaseOptions(),
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.iesapuri\.com/,
      /^https:\/\/api\.stg\.iesapuri\.com/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

if (gtmId) {
  safeInitializeGtm(gtmId)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
